<template>
  
  <div id="modal">
    <div class="container-fluid">
      <p class="linespace95"></p>

      <div class="row">
        <div class="col-12">
          <div class="centertext">
	    <p class="linespace45"></p>
	    <p class="linespace65"></p>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col"> </div>
          <div class="col-auto"> 
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="text-center" style="height:20px;">System is under maintenance</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col"> </div>
        </div>
      </div>
      <p class="linespace45"></p>
      <p class="linespace65"></p>

    </div>
  </div>

  <ErrorDialog />
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import router from '../router';
import { checkMaintenance } from '../server';
import { error } from './ErrorDialog.vue';

async function check()
{
    let res = await checkMaintenance({check_only:true});
    if (res.maintenance) {
	setTimeout(check, 5000);
	return;
    }
    router.push({name: 'Login'});
}

check();

</script>


<style scoped>
.app {
  font-size: 40px;
    color: blue;
}
</style>
